<template lang="pug">
#metadata(v-loading="loading", element-loading-text="数据加载中...")
  splitpanes.default-theme(:dbl-click-splitter="false")
    pane.column-left(min-size="15", size="20")
      //- .name 元数据管理
      el-input(v-model="filterText", placeholder="输入关键字进行过滤", size="small")
      el-tree(
        ref="dataTree",
        :props="defaultProps",
        :load="loadNode",
        node-key="groupId",
        lazy,
        highlight-current,
        :expand-on-click-node="false",
        :filter-node-method="filterNode",
        @node-click="handleNodeClick",
        v-slot="{ node, data }"
      )
        .labelst
          img.imglogo(v-if="data.isGroup === 1", :src="forlderIcon", alt="logo")
          img.imglogo(v-else, :src="formIcon", alt="logo")
          span.titleName(:title="data.groupName", :class="{ theme: node.level < 4 }") {{ node | tree }}
          .oper
            i.el-icon-refresh(v-if="node.level === 3", title="刷新当前节点", @click.stop="loadNextNode(data.groupId)")
            i.el-icon-edit(v-if="node.level === 2", title="修改名称", @click.stop="openDialog(data, 'editName', node)")
            i.el-icon-copy-document(v-else-if="data.templateType === 1 && node.level === 3", title="关联", @click.stop="openDialog(data, 'correlation', node)")
            i.el-icon-circle-plus-outline(v-else-if="showPlusIcon(node, data)", title="添加", @click.stop="openPlus(data, node)")
    pane.column-right(min-size="70", size="80")
      .rightContatiner
        compontent(:is="rightCom",:curNode="sideNode", :clickNode="handleNodeClick", :treeRef="$refs.dataTree" ref="rightCom", @openTypeDialog="openDialog", @initTree="initTree", :key="rightComIndex")
        img.blankBgc(:src="blankImg", alt="", v-if="!rightCom")
  compontent(:is="dataDialog", ref="dataDialog", @initTree="initTree")
</template>

<script>
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
import { mapState } from "vuex";
import metadataService from "@/CommonDP/service/metadata-service.js";
import correlationDialog from "./component/dialog/correlationDialog.vue";
import addFormDialog from "./component/dialog/addFormDialog.vue";
import addTableDialog from "./component/dialog/addTableDialog";
import addModelDialog from "./component/dialog/addModelDialog.vue";
import addCustomDialog from "./component/dialog/addCustomDialog.vue";
import editModelDialog from "./component/dialog/editModelDialog.vue";
import moduleManagement from "./component/moduleManagement/index.vue";
import metaPage from "./component/metaPage/index.vue"; // 业务模型
import metaPageTotal from "./component/metaPageTotal.vue"; // 业务模型 统计
import formPage from "../vForm/designer.vue"; // 表单页面
import formPageTotal from "./component/formPageTotal.vue"; // 表单页面 统计
import tablePage from "./component/tablePage.vue"; // 表格页面
import tablePageTotal from "./component/tablePageTotal.vue"; // 表单页面 统计
import customPage from "./component/customPage.vue"; // 表格页面
import customPageTotal from "./component/customPageTotal.vue"; // 表单页面 统计
import processTotal from "../process/processTotal.vue"; // 业务流程 统计
import processEdit from "../process/processEdit.vue"; // 业务流程
import { template } from "lodash-es";
/**
 * @description 根据其templateType在树上显示节点名称的模板
 * @type {{[templateType:string]:string}}
 */
const labelTemplateMap = {
  0: "${groupName}", // 默认模版
  1: "${groupName}（${groupId}）",
  2: "${groupName}（${formCode}）",
  3: "${groupName}（${formCode}）",
  4: "${groupName}（${formCode}）",
  5: "${groupName}（${flowKey}）"
};
export default {
  name: "MetaData",
  components: { Splitpanes, Pane },
  filters: {
    tree({ data, level }) {
      const baseTemStr = labelTemplateMap[0];
      let templateStr = baseTemStr;
      if (level === 4) templateStr = labelTemplateMap[data.templateType] || baseTemStr;
      return template(templateStr)(data);
    }
  },
  data() {
    return {
      loading: false,
      defaultProps: {
        children: "children",
        label: "groupName",
        isLeaf: "isLeaf"
      },
      filterText: "",
      keyWord: "",
      tableData: [],
      currentPage: 1,
      activeIndex: 0,
      treeData: [],
      rightCom: "",
      dataDialog: "",
      blankImg: require("./icon/level1.png"),
      rightComIndex: 0,
      expandedKeys: [],
      sideNode: {},
      // url 参数中，要跳转的目标节点的 id 的路径
      targetNodeIdPath: []
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    forlderIcon() {
      return require("./icon/forlderIcon.svg");
    },
    formIcon() {
      return require("./icon/formIcon.svg");
    }
  },
  provide() {
    return {
      metaSideNode: () => this.sideNode
    };
  },
  watch: {
    filterText(val) {
      this.$refs.dataTree.filter(val);
    }
  },

  mounted() {
    const idPath = this.$route.query.id || '';
    if (!idPath) {
      return;
    }
    const ids = idPath.split(',');
    this.targetNodeIdPath = ids;
  },

  methods: {
    // 异步树形结构
    async loadNode(node, resolve) {
      if (node.level <= 2) {
        const { data } = await metadataService.getRootNodeDataList(node.data?.groupId || 0);
        let expandKey = "";
        expandKey = this.getExpandKey(data, node.level);
        resolve([...data]);
        await this.$nextTick();
        if (expandKey) {
          // 继续展开子节点
          this.loadNextNode(expandKey);
        }
        if (!node.data?.groupId) {
          this.$refs.dataTree.setCurrentKey(data[0].groupId);
          const cNode = node.childNodes[0];
          this.handleNodeClick(cNode?.data, cNode);
        }
      } else {
        let last = [];
        try {
          const { data } = await metadataService.getChildNodeDataList(node.data.groupId, node.data.templateType);
          last = data?.map((element) => {
            return { ...element, isLeaf: true };
          });
        } finally {
          resolve(last);
          if (node.level === 3) {
            // 处理参数中传过来的数据
            const expandKey = this.getExpandKey(last, node.level);
            console.debug("第三层级的节点，如果有传入的参数，尝试点击节点，key=", expandKey);
            if (expandKey) {
              this.$refs.dataTree.setCurrentKey(expandKey);
              await this.$nextTick();
              const cNode = node.childNodes.find(item => item.data?.groupId === expandKey);
              this.handleNodeClick(cNode?.data, cNode);
            }
          }
        }
      }
    },

    getExpandKey(groups, level) {
      if (!groups || !groups.length) {
        return "";
      }
      if (level > this.targetNodeIdPath.length) {
        return groups[0].groupId;
      }
      const groupId = this.targetNodeIdPath[level];
      const group = groups.find(item => item.groupId === groupId);
      if (group) {
        return groupId;
      }
      return groups[0].groupId;
    },

    initTree(Boolean, currentKey) {
      // // 刷新节点 true 为刷新同级节点
      this.targetNodeIdPath[3] = currentKey;
      this.refrashTreeNode(Boolean);
      if (this.rightCom) {
        this.$refs.rightCom.update?.();
      }
    },
    // 刷新节点 true:刷新同级节点; false:通过节点id找到对应树节点对象
    refrashTreeNode(Boolean) {
      const key = !Boolean ? this.sideNode.data.groupId : this.sideNode.parent.data.groupId;
      this.loadNextNode(key);
    },
    // 刷新对应key的节点并展开
    loadNextNode(key) {
      const node = this.$refs.dataTree.getNode(key);
      //  设置未进行懒加载状态
      node.loaded = false;
      // 重新展开节点就会间接重新触发load达到刷新效果
      node.expand();
    },
    // 是否显示添加按钮
    showPlusIcon(node, data) {
      return node.level === 3 && data.templateType !== 5;
    },
    // 添加按钮弹框
    openPlus(data, node) {
      const plusDescribe = [
        [() => node.level === 1, "addmodel"],
        [() => node.level === 3 && data.templateType === 2, "addForm"],
        [() => node.level === 3 && data.templateType === 3, "addTable"],
        [() => node.level === 3 && data.templateType === 4, "addCustom"]
      ];
      const logo = plusDescribe.find((item) => item[0]());
      logo ? this.openDialog(data, logo[1]) : console.log("未配置添加弹框");
    },
    // 默认展开节点(目前默认：只展开业务模型且业务模型有导入表的节点)
    // getExpandedKeys (data) {
    //   for (const iterator of data) {
    //     if (iterator.groupName === "业务模型" && iterator.children && iterator.children.length > 0) {
    //       this.expandedKeys.push(iterator.groupId);
    //     }
    //     if (iterator.children && iterator.children.length > 0) {
    //       this.getExpandedKeys(iterator.children);
    //     }
    //   }
    // },
    /** @description: 打开弹框
     * @param {data} 节点数据
     * @param {type} 前端定义组件
     * @param {type.addChildren} 添加子组件
     * @param {type.editName} 修改节点名称
     * @param {type.correlation} 业务模型关联
     * @param {type.addForm} 表单页面添加表单
     */
    async openDialog(data, type, node) {
      this.sideNode = node || this.sideNode;
      this.dataDialog = this.dialogMap(type);
      await this.$nextTick();
      const dialogDescribe = {
        addmodel: () => {
          this.$refs.dataDialog.addForm(data);
        },
        editName: () => {
          this.$refs.dataDialog.openEditForm(data);
        },
        correlation: () => {
          this.$refs.dataDialog.correlation(data);
        },
        addForm: () => {
          this.$refs.dataDialog.addForm(data);
        },
        addTable: () => {
          this.$refs.dataDialog.init(data);
        },
        addProcess: () => {
          this.$refs.dataDialog.addProcess(data);
        },
        addCustom: () => {
          this.$refs.dataDialog.init(data);
        }
      };
      dialogDescribe[type]();
    },
    // 弹框MAP组件
    dialogMap(type) {
      const comMap = {
        addmodel: addModelDialog,
        editName: editModelDialog,
        correlation: correlationDialog,
        addForm: addFormDialog,
        addTable: addTableDialog,
        addCustom: addCustomDialog
      };
      return comMap[type];
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.groupName.indexOf(value) !== -1;
    },
    async handleNodeClick(data, node) {
      const rightCom = this.$refs.rightCom;
      if (rightCom && rightCom.beforeLeave) {
        await rightCom?.beforeLeave(node, this.sideNode);
      }
      this.sideNode = node;
      this.getRightList(data, node);
    },
    // 获取右侧组件
    // templateType 字段: * 业务模型 ：1 * 表单页面：2 * 列表页面：3 * 自定义页面：4 * 业务流程：5 * 门户设计：6 * BI看板：7
    getRightList(data, node) {
      if (!node) {
        return;
      }
      this.rightComIndex++;
      if (node.level === 2) {
        this.rightCom = "";
        this.blankImg = require("./icon/level1.png");
        return;
      }
      const componentDescribeMap = [
        // 业务模块管理
        [
          () => node.level === 1,
          () => {
            this.rightCom = moduleManagement;
          }
        ],
        // 点击业务模型统计节点
        [
          () => node.level === 3 && data.templateType === 1,
          async () => {
            this.rightCom = metaPageTotal;
            await this.$nextTick();
            this.$refs.rightCom.queryChildrenData(data);
          }
        ],
        // 点击表单页面统计节点
        [
          () => node.level === 3 && data.templateType === 2,
          async () => {
            this.rightCom = formPageTotal;
            await this.$nextTick();
            this.$refs.rightCom.queryList(data);
          }
        ],
        // 点击列表页面统计节点
        [
          () => node.level === 3 && data.templateType === 3,
          async () => {
            this.rightCom = tablePageTotal;
            await this.$nextTick();
            this.$refs.rightCom.queryList(data);
          }
        ],
        // 自定义
        [
          () => node.level === 3 && data.templateType === 4,
          async () => {
            this.rightCom = customPageTotal;
            await this.$nextTick();
            this.$refs.rightCom.queryList(data);
          }
        ],
        // 点击业务流程统计节点
        [
          () => node.level === 3 && data.templateType === 5,
          async () => {
            this.rightCom = processTotal;
            await this.$nextTick();
            this.$refs.rightCom.setParentNode(data);
          }
        ],
        [
          () => node.level === 3 && data.templateType === 6,
          () => {
            this.rightCom = "";
            this.blankImg = require("./icon/门户设计.png");
          }
        ],
        [
          () => node.level === 3 && data.templateType === 7,
          () => {
            this.rightCom = "";
            this.blankImg = require("./icon/BI看板.png");
          }
        ],
        // 点击业务模型子集
        [
          () => node.level === 4 && data.templateType === 1,
          async () => {
            this.rightCom = metaPage;
            await this.$nextTick();
            this.$refs.rightCom.getcolumnList(data);
          }
        ],
        // 表单页面子集
        [
          () => node.level === 4 && data.templateType === 2,
          async (data) => {
            // 去掉vform自带的缓存功能,防止污染后续的配置
            window.localStorage.removeItem("form__config__backup");
            this.rightCom = formPage;
            await this.$nextTick();
            this.$refs.rightCom.getcolumnList(data);
          }
        ],
        // 表格页面子集
        [
          () => node.level === 4 && data.templateType === 3,
          async (data) => {
            this.rightCom = tablePage;
            await this.$nextTick();
            this.$refs.rightCom.init(data);
          }
        ],
        // 自定义页面子集
        [
          () => node.level === 4 && data.templateType === 4,
          async (data) => {
            this.rightCom = customPage;
            await this.$nextTick();
            // console.log(this.$refs.rightCom);
            this.$refs.rightCom.init(data);
          }
        ],
        // 业务流程子节点
        [
          () => node.level === 4 && data.templateType === 5,
          async () => {
            this.rightCom = processEdit;
            await this.$nextTick();
            this.$refs.rightCom.getDetail(data);
          }
        ]
      ];
      const getDescribe = componentDescribeMap.find((item) => item[0]());
      // 子数组存在则运行子数组中的第二个元素（执行函数）
      getDescribe ? getDescribe[1](data) : console.log("未配置右侧列表数据");
    },
    // 删除
    // deleteGroup (data) {
    //   this.$confirm("确定删除吗？", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //     customClass: "el-message-box"
    //   }).then(async () => {
    //     await metadataService.deleteGroup(data.groupId);
    //     this.$success("已删除");
    //     this.initTree();
    //   }).catch(() => {
    //     this.$message.info("已取消删除");
    //   });
    // },
    // 业务模型回调-数据库加载，关联
    async updateTable(data) {
      this.dataDialog = correlationDialog;
      await this.$nextTick();
      this.$refs.dataDialog.correlation(data);
    }
  }
};
</script>

<style lang="scss" scoped>
#metadata {
  height: 100%;
  padding: var(--middle-space);

  .column-left,
  .column-right {
    background-color: #fff;
    padding: var(--middle-space);
    border-radius: 4px;
  }

  .rightContatiner {
    width: 100%;
    height: 100%;
    // background: url("./icon/background.png") no-repeat;
    background: #fff;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    // padding: 10px;

    .blankBgc {
      user-select: none;
    }
  }

  .el-tree {
    margin-top: 7px;
    height: calc(100% - 40px);
    overflow-y: hidden;
    &:hover{
      overflow-y: overlay !important;
      overflow-y: auto;
    }
  }

  .name {
    font-size: 16px;
    line-height: 30px;
    font-weight: 600;
    letter-spacing: 1px;
    text-align: center;
  }
}

.labelst {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;

  .imglogo {
    width: 18px;
    height: 18px;
    margin-right: 3px;
  }
  .titleName {
    max-width: 160px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .theme {
    font-size: 14px;
    font-weight: 700;
  }

  .forlder {
    font-size: 16px;
    color: #0062d1;
  }

  .oper {
    margin-left: auto;
  }

  i {
    font-size: 16px;
    margin-right: 8px;
  }
}
</style>
<style lang="scss">
.operButton {
  min-width: 60px !important;

  .right {
    display: flex;
    flex-direction: column;

    p {
      cursor: pointer;
      margin-bottom: 7px;
    }

    .del {
      color: #f56c6c;
    }

    .edit {
      color: var(--theme-color);
    }

    .add {
      color: #67c23a;
    }
  }
}
</style>
